import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOSchema from '@/components/base/SEOSchema';
import { testimonials } from '@/mocks/testimonials';
import ContactForm from '@/pages/about/components/ContactForm';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema
        type="AboutPage"
        title="关于我们 - 精选gay片资源导航"
        description="精选gay片资源导航 - 专注于为成年用户提供gay片内容导航、观看指南与资源推荐的专业平台。了解我们的品牌故事、核心价值和联系方式。"
        url="/about"
      />
      <SEOSchema
        type="FAQPage"
        title="常见问题"
        description="关于gay片资源导航平台的常见问题解答"
        url="/about"
        faqs={[
          {
            question: '这个gay片导航网站是免费的吗？',
            answer: '是的，精选gay片导航网站完全免费使用。我们提供gay片分类浏览、深度评鉴文章和平台推荐服务，所有内容均可免费访问。我们通过为优质gay片平台提供推荐服务来维持网站运营。',
          },
          {
            question: '网站推荐的gay片平台安全吗？',
            answer: '我们推荐的每一个gay片平台都经过严格的评测和筛选。评估标准包括平台安全性、隐私保护措施、内容质量和用户口碑等多个维度。我们只推荐正规运营、有良好安全记录的gay片在线观看平台。',
          },
          {
            question: '如何找到适合自己口味的gay片？',
            answer: '你可以通过我们的gay片分类导航系统按类型浏览内容，也可以阅读我们精心撰写的gay片评鉴文章来发现新作品。每个分类都包含详细的介绍和推荐，帮助你快速定位感兴趣的gay片内容。如果你是gay片新手，建议从"gay片品鉴入门"和"gay片观看安全指南"两篇文章开始。',
          },
          {
            question: '网站内容多久更新一次？',
            answer: '我们保持每周至少更新两篇gay片相关文章的频率。新的gay片推荐、平台评测和观影指南会持续推出，确保你始终能够获取到最新的gay片资源和信息。热门分类如欧美gay片和日本gay片的更新频率更高。',
          },
          {
            question: '观看gay片时如何保护隐私？',
            answer: '保护隐私是我们最重视的事项之一。建议使用我们推荐的正规gay片平台观看内容，这些平台通常提供无痕浏览、端到端加密等隐私保护功能。同时，我们网站的"gay片观看安全指南"文章中有详细的隐私保护建议，包括设备设置、支付方式和浏览习惯等方面的指导。',
          },
        ]}
      />

      <Navbar />

      <main className="pt-16">
        {/* Header */}
        <section className="py-12 md:py-16 bg-background-100 border-b border-background-200">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
              关于我们
            </h1>
            <p className="text-foreground-500 leading-relaxed max-w-2xl">
              精选gay片导航致力于为成年用户打造专业、安全、全面的gay片资源导航与观看指南平台。我们相信每一位gay片爱好者都值得拥有更好的观影体验。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5">
                  品牌故事
                </h2>
                <div className="space-y-4 text-foreground-600 leading-relaxed">
                  <p>
                    精选gay片导航诞生于一群gay片爱好者对高品质观影体验的共同追求。我们发现在海量的gay片内容中，找到真正值得观看的作品并非易事——质量参差不齐、分类混乱、缺乏专业评鉴，这些问题困扰着许多gay片观众。
                  </p>
                  <p>
                    因此，我们决定创建一个专注于gay片内容导航与评鉴的平台。通过系统化的gay片分类、深度的内容评鉴和安全的平台推荐，帮助每一位gay片爱好者更高效地发现优质内容，更安全地享受观影体验。
                  </p>
                  <p>
                    自成立以来，我们始终坚持专业、客观、安全的核心原则。每一篇gay片评鉴文章都经过深入的观看和分析，每一个平台推荐都经过严格的多维度评测。我们相信，只有真正用心去做gay片内容导航，才能赢得用户的信任和认可。
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20elegant%20home%20cinema%20setup%20with%20warm%20ambient%20lighting%2C%20luxurious%20leather%20seating%2C%20large%20screen%20with%20soft%20glow%2C%20sophisticated%20interior%20design%2C%20professional%20architecture%20photography%20with%20moody%20atmosphere&width=600&height=450&seq=about-brand&orientation=landscape"
                  alt="精选gay片导航品牌理念 - 专业观影空间"
                  title="精选gay片导航 - 品牌理念"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="py-12 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center">
              我们的核心价值
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-shield-star-line',
                  title: '安全合规',
                  desc: '严格筛选推荐的gay片平台，确保用户隐私安全和合规观影体验。所有内容符合法律法规要求，仅供成年人浏览。',
                },
                {
                  icon: 'ri-file-text-line',
                  title: '专业评鉴',
                  desc: '每一篇gay片文章都由经验丰富的影评人撰写，从多维度进行深度分析，为用户提供有价值的观影参考。',
                },
                {
                  icon: 'ri-folder-open-line',
                  title: '精准分类',
                  desc: '系统化的gay片分类体系，覆盖欧美gay片、亚洲gay片、日本gay片等八大类型，帮助用户快速定位感兴趣的内容。',
                },
                {
                  icon: 'ri-user-voice-line',
                  title: '用户至上',
                  desc: '以用户需求为核心持续优化gay片导航体验。关注每位用户的反馈和建议，不断改进内容和功能。',
                },
                {
                  icon: 'ri-refresh-line',
                  title: '持续更新',
                  desc: '保持高频的内容更新，每周发布新的gay片推荐文章和平台评测，确保信息时效性和实用性。',
                },
                {
                  icon: 'ri-hearts-line',
                  title: '社群共建',
                  desc: '与gay片爱好者社群紧密互动，倾听真实声音，共同打造更优质、更贴近用户需求的gay片内容导航平台。',
                },
              ].map((value) => (
                <div
                  key={value.title}
                  className="p-6 bg-background-50 border border-background-200/70 rounded-lg"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4">
                    <i className={`${value.icon} text-xl text-accent-500`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {value.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Reputation */}
        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {testimonials.map((t) => (
                <div
                  key={t.name}
                  className="p-6 bg-background-100 border border-background-200/70 rounded-lg"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-12 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center">
              常见问题
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: '这个gay片导航网站是免费的吗？',
                  a: '是的，精选gay片导航网站完全免费使用。我们提供gay片分类浏览、深度评鉴文章和平台推荐服务，所有内容均可免费访问。',
                },
                {
                  q: '网站推荐的gay片平台安全吗？',
                  a: '我们推荐的每一个gay片平台都经过严格评测。评估标准包括平台安全性、隐私保护措施、内容质量和用户口碑等多个维度。我们只推荐正规运营的gay片在线观看平台。',
                },
                {
                  q: '如何找到适合自己口味的gay片？',
                  a: '你可以通过gay片分类导航按类型浏览，也可以阅读我们的评鉴文章来发现新作品。如果你是gay片新手，建议从"gay片品鉴入门"和"gay片观看安全指南"开始。',
                },
                {
                  q: '网站内容多久更新一次？',
                  a: '我们保持每周至少更新两篇gay片相关文章，新的推荐、评测和指南会持续推出，确保你获取最新的gay片资源信息。',
                },
                {
                  q: '观看gay片时如何保护隐私？',
                  a: '建议使用我们推荐的正规gay片平台，这些平台通常提供无痕浏览、加密等隐私保护功能。详见"gay片观看安全指南"文章。',
                },
              ].map((faq, i) => (
                <details
                  key={i}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                    <span className="font-heading text-sm font-semibold text-foreground-800 pr-4">
                      {faq.q}
                    </span>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4 text-center">
              联系我们
            </h2>
            <p className="text-foreground-500 text-center mb-10 max-w-lg mx-auto">
              有任何关于gay片资源的建议、合作意向或问题反馈，欢迎通过以下方式联系我们。我们的团队会在24小时内回复。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
              <div className="text-center p-5 bg-background-100 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                  <i className="ri-mail-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@gayfilmnav.com</p>
              </div>
              <div className="text-center p-5 bg-background-100 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                  <i className="ri-shield-check-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">安全建议</h3>
                <p className="text-sm text-foreground-500">security@gayfilmnav.com</p>
              </div>
              <div className="text-center p-5 bg-background-100 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                  <i className="ri-chat-smile-2-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">合作咨询</h3>
                <p className="text-sm text-foreground-500">partner@gayfilmnav.com</p>
              </div>
            </div>

            {/* Contact Form */}
            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}